import { operationalFormsRoute, trainEventRecordOverviewPathRoute, trainEventRecordPathRoute, trainEventRecordSectionPathRoute } from "./OperationalFormsRoutes";

export const allTrainEventRecordRoutes = (): any[] => {
    const routes = [
        operationalFormsRoute,
        trainEventRecordSectionPathRoute,
        trainEventRecordOverviewPathRoute,
        trainEventRecordPathRoute
    ];
    return routes;
};